<template>
  <v-card>
    <v-card-title class="headline top-title">Ajout d'un bien</v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row>
          <v-flex xs6 class="mr-1">
            <h2>Informations</h2>
            <div class="pl-1">
              <v-text-field
                label="Adresse *"
                v-model="instance.address"
                data-vv-name="address"
                required
                v-validate="'required'"
                :error-messages="errors.collect('address')"
              ></v-text-field>
              <v-text-field
                label="Lien *"
                v-model="instance.externalId"
                data-vv-name="externalId"
                required
                v-validate="'required|url'"
                :error-messages="errors.collect('externalId')"
              ></v-text-field>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    label="Surface"
                    v-model="instance.carrez"
                    data-vv-name="carrez"
                    v-validate="'numeric|min_value:1'"
                    :error-messages="errors.collect('carrez')"
                  ></v-text-field>
                </v-flex>
                <v-flex class="ml-1">
                  <v-text-field
                    label="Pièces *"
                    v-model="instance.numberOfRoom"
                    data-vv-name="numberOfRoom"
                    required
                    v-validate="'integer|required|max_value:10|min_value:1'"
                    :error-messages="errors.collect('numberOfRoom')"
                  ></v-text-field>
                </v-flex>
                <v-flex class="ml-1">
                  <v-text-field
                    label="Prix"
                    v-model="instance.price"
                    data-vv-name="price"
                    v-validate="'numeric|min_value:1'"
                    :error-messages="errors.collect('price')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-textarea
                outline
                label="Description"
                v-model="instance.description"
              ></v-textarea>
            </div>
          </v-flex>
          <v-flex xs6 class="ml-1">
            <h2>Photos</h2>
            <div class="pl-1 mb-3">
              <drop-zone
                v-model="instance.photoUrlEstate"
                :edit-mode="true"
              ></drop-zone>
            </div>

            <h2>Contact</h2>
            <div class="pl-1">
              <v-text-field
                label="Nom"
                v-model="instance.contactName"
              ></v-text-field>
              <v-text-field
                label="Téléphone"
                v-model="instance.contactPhoneNumber"
              ></v-text-field>
              <v-text-field
                label="Mail"
                v-model="instance.contactEmail"
                data-vv-name="contactEmail"
                v-validate="'email'"
                :error-messages="errors.collect('contactEmail')"
              ></v-text-field>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="$emit('close')" color="grey">Annuler</v-btn>
      <v-btn flat @click="addHost()" color="primary">Ajouter</v-btn>
    </v-card-actions>
    <v-snackbar v-model="showError" :timeout="7000">
      Une erreur a eu lieu : adresse incorrecte ?
    </v-snackbar>
  </v-card>
</template>

<script>
import DropZone from "./commons/DropZone";
import { fetchHil } from "../utils";

const DEFAULT_VALUES = {
  address: "",
  externalId: "",
  carrez: "",
  price: "",
  numberOfRoom: "",
  description: "",
  photoUrlEstate: [],
  contactName: "",
  contactPhoneNumber: "",
  contactEmail: "",
  publish: true,
  isActive: true,
  geoLoc: null,
};

export default {
  name: "HostsAdd",
  components: { DropZone },
  data: function () {
    return {
      showError: false,
      instance: { ...DEFAULT_VALUES },
    };
  },
  methods: {
    async addHost() {
      if (!(await this.$validator.validateAll())) {
        return;
      }
      try {
        const addrResp = await fetch(
          "https://api-adresse.data.gouv.fr/search/?limit=10&q=" +
            encodeURIComponent(this.instance.address)
        );
        if (!addrResp.ok) {
          throw new Error("geoloc has failed");
        }
        const data = await addrResp.json();
        if (data.features && data.features.length > 0) {
          this.instance.geoLoc = data.features[0].geometry;
        }

        const createResp = await fetchHil(`/hosts`, { method: "POST" });
        if (!createResp.ok) {
          throw new Error("resp has failed");
        }
        const updateResp = await fetchHil(
          `/hosts/${(await createResp.json())._id}`,
          {
            method: "PUT",
            body: this.instance,
          }
        );
        if (!updateResp.ok) {
          throw new Error("resp has failed");
        }
        this.instance = { ...DEFAULT_VALUES };
        this.$emit("added");
      } catch (err) {
        this.showError = true;
        console.error(err);
      }
    },
  },
};
</script>

<style>
h2 {
  color: grey;
  border-bottom: 1px solid grey;
  margin-bottom: 16px;
  margin-top: 8px;
}

.top-title {
  color: white;
  background: #60a694;
}
</style>
